import type { MomentFormatSpecification } from 'moment';
import { freeze } from '@trello/objects';

/**
 * These are all features that have some rollout configuration defined for the
 * sake of in-app "new" messaging.
 */
export type NewFeature =
  | 'AdminInsightsLink'
  | 'BoardBkgdGradients'
  | 'CrossProductSearch'
  | 'PupHeaderHub'
  | 'WorkspaceViewSpotlightExperience'
  | 'WorkspaceLinks'
  // Not a real feature; used exclusively for unit tests. Do not sort!
  | 'TestFeature';

export const MOMENT_FORMAT: MomentFormatSpecification = 'MM-DD-YYYY';
// Mirrors MOMENT_FORMAT.
type DateStringFormat = `${number}-${number}-${number}`;

type ConfigType = Record<
  NewFeature,
  [release: DateStringFormat, expiration: DateStringFormat]
>;

export const FeatureRolloutConfig = freeze<ConfigType>({
  AdminInsightsLink: ['12-01-2021', '05-01-2022'],
  BoardBkgdGradients: ['03-01-2021', '06-01-2021'],
  PupHeaderHub: ['02-01-2022', '04-01-2022'],
  // Following the internal release date for WSV 2.0 as mentioned here:
  // https://hello.atlassian.net/wiki/spaces/TRELLO/pages/1247200437/Release+Plan+WSViews+2.0+Dec+2021
  WorkspaceViewSpotlightExperience: ['11-15-2021', '07-10-2022'], // temp expiration date, set this back to '07-01-2023' after WorkspaceLinks expires
  CrossProductSearch: ['04-01-2022', '09-01-2022'],
  WorkspaceLinks: ['07-11-2022', '08-11-2022'],

  // Defined exclusively for unit tests; don't sort this.
  TestFeature: ['01-01-2021', '01-01-9999'],
});
